import { c as _c } from "react/compiler-runtime";
import { Separator } from "@domainstack/ui/separator";
import { cn } from "@domainstack/ui/utils";
export function AppHeaderSeparator(t0) {
  const $ = _c(4);
  const {
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("!h-4", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <Separator orientation="vertical" className={t1} />;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}